/** Where the push worker is served, in development and in the built app (push design D10). */
export const PUSH_WORKER_PATH = "/push/sw.js";
